export default {"src":"/_next/static/media/bnty.33d0b69c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};